import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { AboveTheFoldOnlyServerRender } from "above-the-fold-only-server-render";
import BaseLayoutSegmentComponent from "/components/segments/base-layout-segment/base-layout-segment-component";
import { SegmentContext } from "/contexts/segment-context";
class SegmentsLayoutListComponent extends PureComponent {
    shouldRenderSegmentOnServer(segmentIndex) {
        let { numberOfAboveTheFoldSegments } = this.props;
        numberOfAboveTheFoldSegments = parseInt(numberOfAboveTheFoldSegments);
        if (!numberOfAboveTheFoldSegments) return true;
        return segmentIndex < numberOfAboveTheFoldSegments;
    }
    render() {
        const { segments, isPreview, isUserLoggedIn, extraProps } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "segments-layout-list-component",
            id: "segments-layout-list-component",
            children: segments.map((segment, index)=>{
                const allowSSR = this.shouldRenderSegmentOnServer(index);
                return /*#__PURE__*/ _jsx(AboveTheFoldOnlyServerRender, {
                    skip: !allowSSR,
                    children: /*#__PURE__*/ _jsx(SegmentContext.Provider, {
                        value: {
                            isFirstSegment: index === 0
                        },
                        children: /*#__PURE__*/ _jsx(BaseLayoutSegmentComponent, {
                            isPreview: isPreview,
                            extraProps: extraProps,
                            segment: segment,
                            isUserLoggedIn: isUserLoggedIn,
                            index: index
                        })
                    })
                }, index);
            })
        });
    }
}
export { SegmentsLayoutListComponent as default };
